/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const SOCKET = project.getFeature(feature.getSettingValue('SOCKET'));
    if (!SOCKET) {
        return blocks;
    }
    const NAME = SOCKET.getSettingValue('NAME');

    const links = project.getNodeLinks(feature, 'sock_data_arrival');
    if (links.length > 0) {
        const link = links[0];

        blocks.push({
            location: `${NAME}_sock_data_arrival`,
            blockType: BlockType.CODE,
            template: `
string data = buffer;
/****${link.getSourceId()}****/
        `,
        });
    }

    return blocks;
};
